<template>
  <input type="hidden" name="_token" :value="token" />
</template>

<script>
export default {
  computed: {
    token() {
      let token = document.head.querySelector('meta[name="csrf-token"]');
      return token ? token.content : "";
    }
  }
};
</script>